/* eslint-disable @typescript-eslint/quotes */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MenuDtlResponse } from "../model/MenuDtlResponse";
import { LoginService } from "../services/login.service";

import { MENU_ITEMS } from "./MenuItems";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent implements OnInit {
  menuItems: MenuDtlResponse[] = [];
  constructor(private router: Router, private loginService: LoginService) {}

  ngOnInit(): void {
    this.getMenuItems();
  }

  changePassword() {
    this.router.navigate(['/secure', 'change-password'], {replaceUrl: true});
  }

  logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("expiresIn");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("roles");
    localStorage.removeItem("userName");

    localStorage.removeItem("assignPageIndex");
    localStorage.removeItem("assignPageSize");
    localStorage.removeItem("PageSize");
    localStorage.removeItem("PageIndex");
    localStorage.removeItem("reload");
    this.router.navigate(['']);
  }

  getMenuItems() {
    this.loginService.fetchMenu().subscribe((data)=>{
      if(data.status === 'SUCCESS') {
        this.menuItems = data.menu;
      }
    });
  }

  // getMenuItems() {
  //   let roles = localStorage.getItem("roles");
  //   if(roles.indexOf("ADMIN") >= 0) {
  //     this.menuItems = [MENU_ITEMS.HOME, {
  //       ...MENU_ITEMS.MASTER, 
  //       children: [
  //         MENU_ITEMS.MASTER_CHILDREN.feature,
  //         MENU_ITEMS.MASTER_CHILDREN.role,
  //         MENU_ITEMS.MASTER_CHILDREN.user,
  //         MENU_ITEMS.MASTER_CHILDREN.organization,
  //         MENU_ITEMS.MASTER_CHILDREN.board
  //       ]
  //     }, MENU_ITEMS.REPORTS, MENU_ITEMS.MODERATION_AUDIT_TRAIL, MENU_ITEMS.PAYMENT_RECONCILIATION, MENU_ITEMS.IMPORT_MASTER];
  //   }
  //   else if(roles.indexOf("MODERATION_MAKER") >= 0 || 
  //     roles.indexOf("MODERATION_CHECKER") >= 0) {
  //     this.menuItems = [MENU_ITEMS.HOME, MENU_ITEMS.MODERATION];
  //   }
  //   else {
  //     this.menuItems = [MENU_ITEMS.AUDIT_TRAIL, MENU_ITEMS.CHAT_BOT];
  //   }
  // }
}
